/* eslint-disable no-undef */
module.exports = (function() {
  'use strict';

  function resetCelebrus() {
    // eslint-disable-next-line no-undef
    if (window.ipcsadoReInit) {
      // eslint-disable-next-line no-undef, new-cap
      window.ipcsadoReInit();
    }
  }

  function resetMeetIds() {
    // eslint-disable-next-line no-undef
    if (typeof setmeetids !== 'undefined') {
      // eslint-disable-next-line no-undef, new-cap
      setmeetids.init();
    }
  }

  function resetGa() {
    // eslint-disable-next-line no-undef
    if (typeof gaRegisterClicks !== 'undefined') {
      // eslint-disable-next-line no-undef, new-cap
      gaRegisterClicks();
    }
  }

  function sendSummaryEventGa4(title, interactionType, interactionLabel) {
if (typeof gtag !== 'undefined') {
      /* eslint-disable camelcase */
      // eslint-disable-next-line no-undef
      gtag('event', title, {interaction_type: interactionType,
        // eslint-disable-next-line camelcase
interaction_label: interactionLabel,
send_to: 'G-7Y6MFDK1ZC'});
      /* eslint-enable camelcase */
    }
  }

  function resetAll() {
    resetCelebrus();
    resetMeetIds();
    resetGa();
  }

  return {
    resetAll: resetAll,
    resetCelebrus: resetCelebrus,
    resetMeetIds: resetMeetIds,
    resetGa: resetGa,
    sendSummaryEventGa4: sendSummaryEventGa4
  };
})();
